import { useCallback } from 'react';
import { PaymentRequestButtonElement } from '@stripe/react-stripe-js';
import { Loader } from '@lingoda/ui';
import type {
    PaymentRequest,
    StripePaymentRequestButtonElementClickEvent,
} from '@stripe/stripe-js';

interface Props {
    paymentRequest?: PaymentRequest;
    onClick: () => void;
    disabled: boolean;
}

export const PaymentRequestButton = ({ paymentRequest, disabled, onClick }: Props) => {
    const handleClick = useCallback(
        (e: StripePaymentRequestButtonElementClickEvent) => {
            onClick();
            if (disabled) {
                e.preventDefault();
            }
        },
        [disabled, onClick],
    );

    if (!paymentRequest) {
        return <Loader />;
    }

    return (
        <PaymentRequestButtonElement
            options={{
                paymentRequest,
                style: {
                    paymentRequestButton: {
                        theme: 'dark',
                        height: '38px',
                    },
                },
            }}
            onClick={handleClick}
            className="PaymentRequestButton"
        />
    );
};
